import React from 'react';
import { Link } from 'react-router-dom';
import { message, Table, Tabs, Popconfirm, Button, Modal, Form, Input, Select } from 'antd';
const FormItem = Form.Item;


export default class extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            serach: {}
        };

    }

    handleFormChange(changedFields) {
        Object.keys(changedFields).forEach((key, index) => {
            this.state.serach[key] = changedFields[key].value;
            this.setState(this.state);
        });
    }
    click() {
        const { handleSerach } = this.props;
        handleSerach(this.state.serach);
    }
    render() {
        let { metadata, handleSerach } = this.props;
        let serach = this.state.serach;
        return (
            <span>
                <SerachForm metadata={metadata} onChange={this.handleFormChange.bind(this)} />
                <Button type="primary" onClick={this.click.bind(this)} >搜索</Button>
            </span>

        )
    }
}

const SerachForm = Form.create({
    onFieldsChange(props, changedFields) {
        props.onChange(changedFields);
    }
})((props) => {
    const { metadata } = props;
    const { getFieldDecorator } = props.form;
    return (
        <Form inline={true}>
            {metadata.map((meta, index) => {
                switch (meta.type) {
                    case 'Input': return <FormItem >
                        {getFieldDecorator(meta.field)(<Input key={index} addonBefore={meta.addonBefore} placeholder={meta.placeholder} />)}
                    </FormItem>;
                    case 'Select': return <FormItem label={meta.label}  >
                        {getFieldDecorator(meta.field)(
                            <Select
                                allowClear
                                placeholder={meta.placeholder}
                                style={{ width: meta.width ? meta.width : 200 }}>
                                {meta.options.map((item, index) => {
                                    return <Option key={index} value={
                                        item.split("|").length > 1 ? item.split("|")[1] : item
                                    }>{
                                        item.split("|").length > 1 ? item.split("|")[0] : item
                                    }</Option>
                                })}
                            </Select>)}
                    </FormItem>;

                }
            })}

        </Form>
    );
});


// WEBPACK FOOTER //
// ./utils/serach.js